import KeywordFilter from "components/filters/Filters/KeywordFilter";
import VisibilityFilter from "components/filters/Filters/VisibilityFilter";
import React from "react";

const Filters = () => {
  return <>
    <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
    <VisibilityFilter
      title={RESX.ExternalCalendar.AutomaticRefresh}
      onlyVisibleLabel={RESX.ExternalCalendar.Active}
      onlyNotVisibleLabel={RESX.ExternalCalendar.Stopped}
    />
  </>;
};

export default Filters;